import { useState, useEffect } from "react";
import { usePergunta } from "../contexts/PerguntaContext";
import { useSalvarConversaNoStorage } from "../hooks/SalvarConversaNoStorage";
import { whatsAppDaPagina } from "../lib/whatsappDaPagina";
import i18n from "../i18n";

interface UseFetchObterWhatsAppsProps {
  slugAtual: string;
}

interface UseFetchObterWhatsAppsReturn {
  loading: boolean;
}

export const ObterWhatsApps = ({
  slugAtual,
}: UseFetchObterWhatsAppsProps): UseFetchObterWhatsAppsReturn => {
  const [loading, setLoading] = useState<boolean>(false);

  const { limparPergunta, conversaAtual } = usePergunta();
  const { salvarConversa } = useSalvarConversaNoStorage();

  useEffect(() => {
    const controller = new AbortController();

    const fetchWhatsapps = async () => {
      setLoading(true);

      let dados: unknown[] = [];
      // Chat aberto por uma landing page: o contato é o WhatsApp da própria página (time de vendas).
      const daPagina = whatsAppDaPagina();
      if (daPagina) {
        salvarConversa(
          slugAtual,
          conversaAtual,
          { assistente: "pediu_ajuda" },
          [],
          [{ img: "", nome: i18n.t("contato_lp"), ultimostatus: "", whatsapp: daPagina }]
        );
        setLoading(false);
        limparPergunta();
        return;
      }
      try {
        const response = await fetch(
          `https://app.sak.com.br/centralAjudaApi/getwhatsapps/${slugAtual}`,
          {
            method: "GET",
            signal: controller.signal,
          }
        );

        if (!response.ok) {
          throw new Error(`status ${response.status}`);
        }

        const data = await response.json();
        dados = Array.isArray(data?.dados) ? data.dados : [];
      } catch (err: any) {
        if (controller.signal.aborted) return;
        console.error(err);
      }

      // Mesmo sem contatos (ou com erro) a mensagem é gravada: o cartão de encaminhamento
      // mostra o aviso, e o campo de digitação é liberado em vez de ficar travado.
      salvarConversa(
        slugAtual,
        conversaAtual,
        { assistente: "pediu_ajuda" },
        [],
        dados
      );
      setLoading(false);
      limparPergunta();
    };

    fetchWhatsapps();

    return () => {
      controller.abort();
    };
  }, [slugAtual, limparPergunta]);

  return { loading };
};
